<div class="sender">
  <div class="dark-blue">
    <nestas-toolbar [steps]="[]"></nestas-toolbar>
  </div>
  <div class="wrap profile-component">
    <mat-card align="center">
      <div class="mat-card-wrapper">
        <div *ngIf="accepted">
          {{translate.instant('SENDER.ACCEPTED')}}
        </div>

        <div *ngIf="!accepted">
          {{translate.instant('SENDER.NOT_ACCEPTED')}}
        </div>

        <br />

        {{translate.instant('SENDER.PROFILE')}}
        <ul class="profile">
          <li (click)="goToProfile()">
            <i class="material-icons ic-icon">account_circle</i>&nbsp;
            <a class="step">{{translate.instant('TOOLBAR.STEP.PROFILE')}}</a>
          </li>
        </ul>
        <br />

        <button mat-raised-button (click)="done()" color="primary" class="confirm-btn cursor">
          {{translate.instant('MAIL.NOTIFICATION_SUMMARY.BUTTON')}}
        </button>

      </div>

    </mat-card>
  </div>
</div>